import React, { useEffect, useState } from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import { Script } from 'gatsby'

const Auction = ({ context }) => {
  const { pathname } = context.location
  const { showTabs } = context

  const BidJSQuery = useStaticQuery(graphql`
    query BidJSTabQuery {
      prismicConfig {
        ...PrismicConfigFragment
      }
    }
  `)
  const configData = BidJSQuery.prismicConfig.data
  const tabs = [
    { name: `${configData.auction || 'Auction'}`, href: '../auction/#!/' },
    { name: `${configData.marketplace || 'Marketplace'}`, href: '../auction/#!/marketplace' },
    { name: `${configData.private_treaty || 'Private Treaty'}`, href: '../private-treaty/' }
  ]

  const [bidJsPage, setBidJsPage] = useState('')

  useEffect(() => {
    const { hash } = context.location
    setBidJsPage(hash?.split('?')[0]?.split('/')[1] || 'auction')
  }, [context.location, pathname])

  return (
    <section className='component-auction mx-auto max-w-screen-xl overflow-hidden p-6'>
      {showTabs && (
        <div className='border-b border-gray-200'>
          <nav className='-mb-px flex justify-around md:justify-start' aria-label='Tabs'>
            {tabs.map((tab) => {
              return (
                <a
                  key={tab.name}
                  className={`${
                    bidJsPage === tab.name.toLowerCase() ? 'border-blue-800 text-blue-900' : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700'
                  } w-auto border-b-2 py-4 text-center font-medium md:px-8`}
                  href={tab.href}
                  onClick={() => setBidJsPage(tab.name.toLowerCase())}>
                  {tab.name}
                </a>
              )
            })}
          </nav>
        </div>
      )}
      <Script
        id='bid-js-config'
        strategy='idle'
        dangerouslySetInnerHTML={{
          __html: `
            window.bidjs = {
              config: {
                clientId: '${process.env.GATSBY_BIDJS_CLIENT_ID}',
                googleMapsApiKey: '${process.env.GATSBY_BIDJS_GOOGLE_API_KEY}',
                region: '${process.env.GATSBY_BIDJS_REGION}',
                server: '${process.env.GATSBY_BIDJS_SERVER}',
              },
              options: {
                allowTitleChange: true,
                allowMetaDescriptionChange: true,
                analyticsCode: '${process.env.GATSBY_COMPANY_GA}',
                analyticsNamespace: 'app',
                enablePaginationTop: true,
                imageCropMode: 'pad',
                imagePadColor: 'rgb:ffffff',
                itemsPerPageDefault: 24,
                scrollOnNavigationElementId: '___gatsby',
                searchPlaceholder: '${configData.search || 'Search'}',
                standalone: false,
                unsupportedBrowserMessage: 'Your browser is not supported. Please use a browser such as Google Chrome or Microsoft Edge to ensure full functionality',
              },
              modules: {
                lotDetails: '/auction/#!/auctions/%AUCTION_ID%/listings/%ITEM_ID%',
                marketplaceLotDetails: '/auction/#!/marketplace/listings/%ITEM_ID%'
              },
              callback: function (event) {
                switch (event.action) {
                  case 'BIDJS_LOADED':
                  case 'BIDJS_MODULES_LOADED':
                    window.prerenderReady = true
                  break
                  case 'BIDJS_NAVIGATED':
                  case 'BIDJS_MODULES_NAVIGATED':
                    if (window.toggleNavState) window.toggleNavState(event.data.path.split('/')[1].replace('Secure?',''))
                }
              }
            }
          `
        }}
      />
      <div className='bidlogix-app bidjs-app pt-4'>
        <div id='bidlogix-modal' />
      </div>
      <div className='bidlogix-app'>
        <div id='bidjs' className={`bidjs-app relative ${bidJsPage}`} />
      </div>
    </section>
  )
}

export default Auction
